import { AuthenticationService } from './../../../service/authentication.service';
import { WebsocketService } from './../../../service/websocket.service';
import { Subscription, of } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { Activity, ActivityTaskHost } from 'src/app/model/SolutionInfo';
import { ModalConfig } from '../../controls/modal/modal-config';
import { ModalRef } from '../../controls/modal/modal-ref';
import { EventService } from 'src/app/service/event.service';
import { Events } from 'src/app/service/websocket.service';
import { ActivityCapabilities } from 'src/app/model/TaskStatus';
import { ActivityService } from 'src/app/service/activity.service';
import { catchError, finalize, tap } from 'rxjs/operators';
import { SoftwareInventoryService } from 'src/app/service/software-inventory.service';
import { BaseComponent } from 'src/app/model/BaseComponent';
import { TranslationUtils } from 'src/app/app-translation-utils';
import { Modal } from '../../controls/modal/modal.service';
import { SolutionService } from 'src/app/service/solution.service';

@Component({
    selector: 'app-activity-software-rollback',
    templateUrl: './activity-software-rollback.component.html',
    styleUrls: ['./activity-software-rollback.component.css'],
    standalone: false
})
export class ActivitySoftwareRollbackComponent extends BaseComponent implements OnInit {

  currentActivity:Activity;
  isRollingback:boolean;
  targetSystemsBusy:boolean;
  rollbackBtnText:string = $localize`Yes`;
  rollbackComplete:boolean;
  rollbackSuccess:boolean;
  offlineAgents:string[] = [];
  height:string = '250px';
  loading:boolean = true;
  id:number;
  pluginId:string;

  eventMessageSubscription:Subscription;
  capabilities:ActivityCapabilities;

  isError: boolean = false;
  errorMessage: string;

  constructor(private modalConfig: ModalConfig, private modalRef: ModalRef,
              private activitySerivce: ActivityService, private wsService:WebsocketService,
              protected eventService: EventService, protected authService: AuthenticationService,
              private siService: SoftwareInventoryService, protected modal:Modal,
              protected solutionService: SolutionService) {
    super(eventService, modal, authService, solutionService);
    this.capabilities = this.modalConfig.data.capabilities;
   }

  ngOnInit(): void {
    this.eventMessageSubscription = this.eventService.eventMessage$.subscribe(msg => {
      if(msg.eventType == Events.Rollback){
        let rollbackSuccess:boolean = msg.body.ok;

        if(rollbackSuccess){
          this.modalRef.close(true);
        }else{
          this.rollbackComplete = true;
          this.isRollingback = false;
          this.rollbackBtnText = $localize`Close`;
        }
      }
    });

    this.activitySerivce.getActivityById(this.capabilities.id)
    .pipe(
      tap(resp => {
        this.currentActivity = resp.body;
      }),
      finalize(() => {
        this.loading = false;
      })).subscribe();
  }

  ngOnDestroy(){
    this.eventMessageSubscription.unsubscribe();
  }

  rollback(): void {
    let systems:string[] = [];
    this.offlineAgents = [];
    this.currentActivity.hostTasks.forEach((host:ActivityTaskHost) => {
      systems.push(host.macAddress);
    });

    this.activitySerivce.isAgentsOnline(systems).pipe(
      tap(resp => {
        let offlineSystems:string[] = resp.body;

        //all systems are online
        if(offlineSystems.length == 0){
          //check if systems are busy
          this.activitySerivce.isTargetSystemsBusy(systems).pipe(
            tap(resp => {
              this.targetSystemsBusy = resp.body;
              //if busy
              if(this.targetSystemsBusy){
                this.isRollingback = false;
              }else{
                this.isRollingback = true;
                this.siService.sendSoftwareRollback(this.wsService.getClientId(), this.wsService.getWSEnvId(), this.addTransaction(),
                  this.currentActivity.id, this.authService.getLoggedInUser().userId, this.capabilities).pipe(
                    tap(resp => {
                      this.rollbackBtnText = $localize`Rolling back software changes...`;
                    }),
                    catchError(resp => {
                      this.isError = true;
                      this.errorMessage = TranslationUtils.getTaskErrorMessage("SOFTWARE_ROLLBACK", undefined);
                      this.isRollingback = false;
                      return of(resp);
                    })).subscribe();
              }
            })
          ).subscribe();
        }else{
          offlineSystems.forEach((offlineSystem:string) => {
            this.currentActivity.hostTasks.forEach((host:ActivityTaskHost) => {
              if(host.macAddress == offlineSystem){
                this.offlineAgents.push(host.name);
              }
            });
          });
        }
      }),
      finalize(() => {
        this.loading = false;
      })
    ).subscribe();
  }

  close(): void {
    this.modalRef.close(false);
  }
}
